import _extends from 'babel-runtime/helpers/extends';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import ArrowRight from '@wh/svg-icons/ArrowRight';
import ArrowLeft from '@wh/svg-icons/ArrowLeft';
import { withTranslator } from '@wh/ui-translations';
import translationContext from '../translationContext';
import * as style from './CarouselArrow.style';
import { getAllowedAttributes } from '../props-filters';

var CarouselArrow = function (_PureComponent) {
  _inherits(CarouselArrow, _PureComponent);

  function CarouselArrow() {
    _classCallCheck(this, CarouselArrow);

    return _possibleConstructorReturn(this, (CarouselArrow.__proto__ || _Object$getPrototypeOf(CarouselArrow)).apply(this, arguments));
  }

  _createClass(CarouselArrow, [{
    key: 'render',
    value: function render() {
      var _cx;

      var _props = this.props,
          t = _props.t,
          direction = _props.direction,
          onClick = _props.onClick,
          disabled = _props.disabled,
          theme = _props.theme,
          arrowStyle = _props.arrowStyle,
          restProps = _objectWithoutProperties(_props, ['t', 'direction', 'onClick', 'disabled', 'theme', 'arrowStyle']);

      var translator = translationContext(t);
      var Icon = { left: ArrowLeft, right: ArrowRight }[direction] || React.createElement('span', null);
      var label = { left: translator('scroll_left'), right: translator('scroll_right') }[direction];

      var className = cx(style.arrow, (_cx = {}, _defineProperty(_cx, style.arrowLight, theme === 'light'), _defineProperty(_cx, style.arrowDark, theme === 'dark'), _defineProperty(_cx, style.arrowActive, !disabled), _cx));
      var allowedAttributes = getAllowedAttributes(restProps);
      return React.createElement(
        'button',
        _extends({
          'aria-label': label
        }, allowedAttributes, {
          className: className,
          onClick: !disabled ? onClick : undefined,
          disabled: disabled,
          style: arrowStyle
        }),
        React.createElement(Icon, null)
      );
    }
  }]);

  return CarouselArrow;
}(PureComponent);

CarouselArrow.propTypes = {
  t: PropTypes.func.isRequired,
  direction: PropTypes.oneOf(['left', 'right']),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  theme: PropTypes.oneOf(['light', 'dark']).isRequired,
  arrowStyle: PropTypes.shape({
    hidden: PropTypes.string
  })
};


export default withTranslator(CarouselArrow);